import { render, staticRenderFns } from "./BasicBox.vue?vue&type=template&id=d1e095bc&"
import script from "./BasicBox.vue?vue&type=script&lang=js&"
export * from "./BasicBox.vue?vue&type=script&lang=js&"
import style0 from "./BasicBox.vue?vue&type=style&index=0&id=d1e095bc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports